const INSPECTION_COMPONENTS = new Set([
    'inspection_view',
    'thermal_inspection_view',
]);

export function getDatasetUuid(view = null) {
    const uuid = view?.datasetPackage?.uuid;
    return uuid === undefined || uuid === null ? null : String(uuid);
}

export function isInspectionView(view = null) {
    return INSPECTION_COMPONENTS.has(view?.component);
}

export function findContextRailOwner(views = [], sourceView = null) {
    const datasetUuid = getDatasetUuid(sourceView);
    if (!datasetUuid) {
        return null;
    }

    if (isInspectionView(sourceView)) {
        return sourceView;
    }

    return (
        views.find(
            view =>
                isInspectionView(view) &&
                getDatasetUuid(view) === datasetUuid
        ) || null
    );
}

export function buildContextRailRequest(
    views = [],
    sourceView = null,
    mode = 'review'
) {
    const owner = findContextRailOwner(views, sourceView);
    const datasetUuid = getDatasetUuid(sourceView);
    if (!owner || !datasetUuid) {
        return null;
    }

    return {
        open: true,
        mode: mode === 'context' ? 'context' : 'review',
        datasetUuid,
        sourceViewId: sourceView.id,
        ownerViewId: owner.id,
    };
}

export function reconcileContextRail(views = [], contextRail = null) {
    if (!contextRail?.open || !contextRail.datasetUuid) {
        return null;
    }

    const datasetUuid = String(contextRail.datasetUuid);
    const owner =
        views.find(
            view =>
                String(view.id) === String(contextRail.ownerViewId) &&
                isInspectionView(view) &&
                getDatasetUuid(view) === datasetUuid
        ) ||
        views.find(
            view =>
                isInspectionView(view) &&
                getDatasetUuid(view) === datasetUuid
        );

    if (!owner) {
        return null;
    }

    const source =
        views.find(
            view =>
                String(view.id) === String(contextRail.sourceViewId) &&
                getDatasetUuid(view) === datasetUuid
        ) || owner;

    return {
        open: true,
        mode: contextRail.mode === 'context' ? 'context' : 'review',
        datasetUuid,
        sourceViewId: source.id,
        ownerViewId: owner.id,
    };
}
